// api/auth.js
import apiService from "../services/api";

export const authAPI = {
  // Регистрация пользователя
  register: async (userData) => {
    const response = await apiService.post("/user/auth/register/", userData);

    // Сохраняем токены если они приходят при регистрации
    if (response.access) {
      localStorage.setItem("access", response.access);
      if (response.refresh) {
        localStorage.setItem("refresh", response.refresh);
      }
      if (response.user) {
        localStorage.setItem("user", JSON.stringify(response.user));
      }
    }

    return response;
  },

  // Вход в систему
  signIn: async (credentials) => {
    const response = await apiService.post("/user/auth/login/", credentials);

    // Сохраняем токены и данные пользователя
    if (response.access) {
      localStorage.setItem("access", response.access);
      if (response.refresh) {
        localStorage.setItem("refresh", response.refresh);
      }
      if (response.user) {
        localStorage.setItem("user", JSON.stringify(response.user));
      }
    }

    return response;
  },

  // Выход из системы
  signOut: () => {
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    localStorage.removeItem("user");
  },

  // Получить текущего пользователя
  getCurrentUser: () => {
    const userStr = localStorage.getItem("user");
    return userStr ? JSON.parse(userStr) : null;
  },

  // Проверка авторизации
  isAuthenticated: () => {
    return !!localStorage.getItem("access");
  },

  // Обновление токена
  refreshToken: async () => {
    const refreshToken = localStorage.getItem("refresh");
    if (!refreshToken) throw new Error("No refresh token");

    const response = await apiService.post("/auth/refresh", {
      refresh: refreshToken,
    });

    if (response.access) {
      localStorage.setItem("access", response.access);
    }

    return response;
  },
};
